import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EntityUsageDialogData } from './cpq-usage-dialog.model';

@Component({
    selector: 'cpq-cpq-usage-dialog',
    templateUrl: './cpq-usage-dialog.component.html',
    styleUrls: ['./cpq-usage-dialog.component.scss'],
    standalone: false
})
export class CpqUsageDialogComponent {
  public entityUsageData: EntityUsageDialogData;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  private dialogRef: MatDialogRef<CpqUsageDialogComponent>,) {
  }

  ngOnInit(): void {
    this.entityUsageData = this.data;
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
